/**
 * Shared helpers for the hearing quiz funnel: visitor UUID fallback + GA4 client_id.
 * Exposes window.AudienHqfUtils — load before hearing-quiz-funnel.js.
 */
(function (global) {
  'use strict';

  var STORAGE_KEY_FALLBACK_VISITOR_ID = 'audien_visitor_id';
  var STORAGE_KEY_GA4_CLIENT_ID = 'audien_ga4_client_id';
  var REGEX_GA4_CLIENT_ID = /^\d+\.\d+$/;
  var UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  function generateVisitorUuid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function isUuidV4Like(s) {
    return typeof s === 'string' && UUID_V4_REGEX.test(s);
  }

  function getOrCreateFallbackVisitorUuid() {
    var existing = null;
    try {
      existing = localStorage.getItem(STORAGE_KEY_FALLBACK_VISITOR_ID);
    } catch (err) {}
    if (!!existing && isUuidV4Like(existing)) return existing;
    var fromSession = null;
    try {
      fromSession = sessionStorage.getItem(STORAGE_KEY_FALLBACK_VISITOR_ID);
    } catch (err2) {}
    if (!!fromSession && isUuidV4Like(fromSession)) {
      try {
        localStorage.setItem(STORAGE_KEY_FALLBACK_VISITOR_ID, fromSession);
      } catch (err3) {}
      return fromSession;
    }
    var id = generateVisitorUuid();
    try {
      localStorage.setItem(STORAGE_KEY_FALLBACK_VISITOR_ID, id);
    } catch (err4) {}
    return id;
  }

  function parseGa4ClientIdFromCookie() {
    var match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
    if (!match) return null;
    var raw = decodeURIComponent(match[1].trim());
    var parts = raw.split('.');
    if (parts.length < 4) return null;
    var a = parts[parts.length - 2];
    var b = parts[parts.length - 1];
    if (!/^\d+$/.test(a) || !/^\d+$/.test(b)) return null;
    return a + '.' + b;
  }

  function readGa4ClientIdFromLocalStorage() {
    try {
      var cached = localStorage.getItem(STORAGE_KEY_GA4_CLIENT_ID);
      if (!!cached && REGEX_GA4_CLIENT_ID.test(cached)) return cached;
    } catch (err) {}
    return null;
  }

  /** @returns {string|null} normalized id or null if invalid */
  function writeGa4ClientIdToLocalStorage(raw) {
    if (raw == null || raw === '') return null;
    var s = String(raw).trim();
    if (!REGEX_GA4_CLIENT_ID.test(s)) return null;
    try {
      localStorage.setItem(STORAGE_KEY_GA4_CLIENT_ID, s);
    } catch (err) {}
    return s;
  }

  global.AudienHqfUtils = {
    STORAGE_KEY_FALLBACK_VISITOR_ID: STORAGE_KEY_FALLBACK_VISITOR_ID,
    STORAGE_KEY_GA4_CLIENT_ID: STORAGE_KEY_GA4_CLIENT_ID,
    REGEX_GA4_CLIENT_ID: REGEX_GA4_CLIENT_ID,
    generateVisitorUuid: generateVisitorUuid,
    isUuidV4Like: isUuidV4Like,
    getOrCreateFallbackVisitorUuid: getOrCreateFallbackVisitorUuid,
    parseGa4ClientIdFromCookie: parseGa4ClientIdFromCookie,
    readGa4ClientIdFromLocalStorage: readGa4ClientIdFromLocalStorage,
    writeGa4ClientIdToLocalStorage: writeGa4ClientIdToLocalStorage
  };
})(typeof window !== 'undefined' ? window : this);
